import {
  ApiBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import {
  configApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { jiraApiRef } from './api/JiraApi';
import { DefaultJiraClient } from './api/DefaultJiraClient';

export const jiraPlugin = createFrontendPlugin({
  pluginId: 'jira',
  extensions: [
    ApiBlueprint.make({
      name: 'jira',
      params: params =>
        params({
          api: jiraApiRef,
          deps: {
            discoveryApi: discoveryApiRef,
            fetchApi: fetchApiRef,
            configApi: configApiRef,
          },
          factory: ({ discoveryApi, fetchApi, configApi }) =>
            new DefaultJiraClient(discoveryApi, fetchApi, configApi),
        }),
    }),
  ],
});
